import React from 'react';
import PropTypes from 'prop-types';

const roomTypes = [
  { id: 'small_portable', label: 'Small Portable' },
  { id: 'medium_portable', label: 'Medium Portable' },
  { id: 'large_portable', label: 'Large Portable' },
  { id: 'small_walkin', label: 'Small Walk-in' },
  { id: 'medium_walkin', label: 'Medium Walk-in' },
  { id: 'large_walkin', label: 'Large Walk-in' },
  { id: 'custom', label: 'Custom Size' },
];

const RoomSizeStep = ({ formData, handleInputChange, errors }) => {
  return (
    <div>
      <div className="mb-4">
        <label htmlFor="roomType" className="block text-gray-700 text-sm font-bold mb-2">
          Type of Cool Room
        </label>
        <select
          id="roomType"
          name="roomType"
          value={formData.roomType || ''}
          onChange={handleInputChange}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          required
        >
          <option value="">Select room type</option>
          {roomTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.label}
            </option>
          ))}
        </select>
        {errors.roomType && <p className="mt-1 text-sm text-red-500">{errors.roomType}</p>}
      </div>

      <div className="mb-4">
        <label htmlFor="capacity" className="block text-gray-700 text-sm font-bold mb-2">
          Capacity (in cubic meters)
        </label>
        <input
          type="number"
          id="capacity"
          name="capacity"
          value={formData.capacity || ''}
          onChange={handleInputChange}
          placeholder="Enter capacity in cubic meters"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          min="0"
          step="0.1"
          required
        />
        {errors.capacity && <p className="mt-1 text-sm text-red-500">{errors.capacity}</p>}
      </div>

      <div className="mb-4">
        <label htmlFor="sizeComment" className="block text-gray-700 text-sm font-bold mb-2">
          Additional Size Comments (optional)
        </label>
        <textarea
          id="sizeComment"
          name="sizeComment"
          value={formData.sizeComment || ''}
          onChange={handleInputChange}
          placeholder="Enter any additional comments about size requirements"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          rows="3"
        />
      </div>

      <div className="mb-4">
        <p className="text-gray-700 text-sm mb-2">
          Not sure about the size? Provide some details about what you need to store:
        </p>
        <textarea
          id="storageDetails"
          name="storageDetails"
          value={formData.storageDetails || ''}
          onChange={handleInputChange}
          placeholder="Describe what you need to store in the cool room"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          rows="4"
        />
      </div>
    </div>
  );
};

RoomSizeStep.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default RoomSizeStep;